import Inputmask from 'inputmask'

const maskPatterns = {
    date: {
        mask: 'datetime',
        inputFormat: 'dd/mm/yyyy',
        placeholder: '__/__/____',
    },
}

/**
 * Inputmask 5.0.9 throws in keyEvent when KeyboardEvent#key is undefined (Sentry: inputmask length).
 */
function guardKeyboardEventKey(element) {
    const normalize = (event) => {
        if (event.key !== undefined && event.key !== null) {
            return
        }

        Object.defineProperty(event, 'key', {
            value: '',
            configurable: true,
        })
    }

    element.addEventListener('keydown', normalize, true)
}

export function initMask(element, type) {
    const { mask, inputFormat, placeholder } = maskPatterns[type]

    if (mask) {
        guardKeyboardEventKey(element)

        const inputMask = new Inputmask(mask, {
            showMaskOnHover: false,
            showMaskOnFocus: false,
            inputFormat,
            placeholder,
        })

        inputMask.mask(element)
    }
}

window.initMask = initMask
